import React, {
  useCallback, useEffect, useMemo, useState,
} from 'react';

import classnames from 'classnames';
import qDocPromise from '../js/qDoc';

const placeholders = ['A1', 'B1', 'C1', 'D1', 'A2', 'B2', 'C2', 'D2', 'Winner QF1', 'Winner QF2', 'Winner QF3', 'Winner QF4', 'Loser SF1', 'Loser SF2', 'Winner SF1', 'Winner SF2'];

const styles = require('./TeamFilter-styles.css');

const Current = () => {
  const [qDoc, setQDoc] = useState(null);
  const [qObj, setQObj] = useState(null);
  const [data, setData] = useState(null);
  const handleTeamClick = useCallback((event) => {
    const qElemNo = Number(event.target.dataset.qElemNo);
    qObj.selectListObjectValues('/qListObjectDef', [qElemNo], true);
  }, [qDoc, qObj]);
  useEffect(() => {
    (async () => {
      try {
        const _qDoc = await qDocPromise;
        setQDoc(_qDoc);
        const _qObj = await _qDoc.createSessionObject({
          qInfo: { qType: 'data' },
          qListObjectDef: {
            qDef: { qFieldDefs: ["=If(d_DateYear = '$(vYear)', TeamName)"], qSortCriterias: [{ qSortByAscii: 1 }] },
          },
        });
        setQObj(_qObj);
        _qObj.on('changed', async () => {
          setData(await _qObj.getListObjectData('/qListObjectDef', [{ qWidth: 1, qHeight: 50 }]));
        });
        setData(await _qObj.getListObjectData('/qListObjectDef', [{ qWidth: 1, qHeight: 50 }]));
      } catch (error) {
        console.log(error); //eslint-disable-line
      }
    })();
  }, []);
  useEffect(() => () => {
    if (qDoc) qDoc.clearAll();
    if (qObj) qDoc.destroySessionObject(qObj.id);
  }, []);
  const teams = useMemo(() => data && data[0].qMatrix.filter((team) => !placeholders.includes(team[0].qText)), [data]);
  return (
    <div>
      <div className={styles.header}>TEAMS</div>
      <div className={styles.list}>
        {teams && teams.map((team) => (
          <div key={team[0].qElemNumber} data-q-elem-no={team[0].qElemNumber} className={classnames(styles.team, styles[team[0].qState])} onClick={handleTeamClick}>
            {team[0].qText}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Current;
